import SubscribeEventsToggle from './_subscribe-events-toggle.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import Button from './_button.js'
import DownloadBetPdfButton from './_download-bet-pdf-button.js'
import PayableInfo from './_payable-info.js'
import FreebetStakeInfo from './_freebet-stake-info.js'
import CashStakeInfo from './_cash-stake-info.js'
import PrewagerStakeInfo from './_prewager-stake-info.js'
import StakeTaxInfo from './_stake-tax-info.js'
import StakeInfo from './_stake-info.js'
import TotalPayoutInfo from './_total-payout-info.js'
import PayoutInfo from './_payout-info.js'
import DateTime from './_date-time.js'
import BetView from './_bet-view.js'
import ShareBet from './_share-bet.js'

export default {
  name: 'BetReceiptView',
  values: {
    showRetainSelections: true,
    showOkButton: true,
    subscribeEventsToggle: {
      configSet: SubscribeEventsToggle,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
            minHeight: '40px',
            maxHeight: '40px',
          },
        },
      },
    },
    pdfErrorContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          minHeight: '25px',
          padding: '8px',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
          flexBasis: '0px',
          padding: '8px 8px 16px 8px',
        },
      },
    },
    receiptNbrAndLinesContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    typePriceAndLine: {
      configSet: Text,
      configValues: {},
    },
    receiptNbr: {
      configSet: Text,
      configValues: {},
    },
    deviceId: {
      configSet: Text,
      configValues: {},
    },
    betReceiptHeader: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          flexGrow: 0,
        },
      },
    },
    betReceiptHeaderTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    betReceiptHeaderSuccessText: {
      configSet: Text,
      configValues: {},
    },
    betReceiptHeaderSuccessTextl10nKey: '$BET_RECEIPT.HEADER',
    betReceiptHeaderDateText: {
      configSet: Text,
      configValues: {},
    },
    headerIcon: {
      configSet: Image,
      configValues: {},
    },
    betReceiptBodyContainer: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '1px',
          },
        },
        style: {
          flexDirection: 'column',
          flexGrow: 0,
        },
      },
    },
    totalsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    buttonsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '16px 0 0 0',
          justifyContent: 'space-between',
        },
      },
    },
    okButton: {
      configSet: Button,
      configValues: {},
    },
    clearButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: '50%',
          },
        },
      },
    },
    clearButtonLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          textAlign: 'center',
        },
      },
    },
    retainButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexBasis: '50%',
          },
        },
      },
    },
    retainButtonLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        style: {
          textAlign: 'center',
        },
      },
    },
    hideDownloadPdfButton: true,
    downloadBetPdfButton: {
      configSet: DownloadBetPdfButton,
      configValues: {
        style: {
          text: {
            paddingLeft: '8px',
          },
        },
        button: {
          style: {
            base: {
              minHeight: '40px',
              minWidth: '40px',
              alignItems: 'center',
            },
          },
        },
      },
    },
    totalFundsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          padding: '16px 0 0 0',
        },
      },
    },
    totalPayable: {
      configSet: PayableInfo,
      configValues: {},
    },
    freebetStake: {
      configSet: FreebetStakeInfo,
      configValues: {},
    },
    cashStake: {
      configSet: CashStakeInfo,
      configValues: {},
    },
    prewager: {
      configSet: PrewagerStakeInfo,
      configValues: {},
    },
    stakeTax: {
      configSet: StakeTaxInfo,
      configValues: {},
    },
    primaryTotalStake: {
      configSet: StakeInfo,
      configValues: {},
    },
    secondaryTotalStake: {
      configSet: StakeInfo,
      configValues: {},
    },
    totalPayoutInfo: {
      configSet: TotalPayoutInfo,
      configValues: {},
    },
    oddsBoostInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
    betPlacementDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE_TIME',
      },
    },
    betView: {
      configSet: BetView,
      configValues: {
        showTotalStakeLabel: true,
        header: {
          style: {
            lineHeight: '35px',
          },
        },
        fundsContainer: {
          style: {
            padding: '8px 0 16px 0',
          },
        },
      },
    },
    shareBet: {
      configSet: ShareBet,
      configValues: {
        showShareButtonLabel: false,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
